module.exports = __webpack_public_path__ + "static/media/logo.7965c57e.svg";